var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21933_10811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.6667H5C5.55312 14.6667 6 14.2411 6 13.7143C6 13.1875 5.55312 12.7619 5 12.7619H3C2.44781 12.7619 2 12.3355 2 11.8096V4.19052C2 3.66462 2.44781 3.23814 3 3.23814H5C5.55312 3.23814 6 2.81165 6 2.28576C6 1.75986 5.55312 1.33337 5 1.33337H3C1.34312 1.33337 0 2.61254 0 4.19052V11.8096C0 13.3869 1.34312 14.6667 3 14.6667ZM15.775 7.47921L11.2719 3.43159C11.0539 3.23581 10.7344 3.18233 10.4594 3.29486C10.1843 3.40787 10.0059 3.66599 10.0059 3.95111L10.0031 6.09397L6.00307 6.09394C5.45026 6.09394 5.00244 6.52043 5.00244 7.04632V8.95108C5.00244 9.47698 5.45057 9.90346 6.00307 9.90346L10.0031 9.90349L10.0059 12.0196C10.0059 12.3046 10.1843 12.5627 10.4594 12.6758C10.7345 12.7883 11.0541 12.7349 11.2719 12.5391L15.775 8.49147C16.075 8.25004 16.075 7.75004 15.775 7.47921Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21933_10811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.c17b65ae07662363a09784e296390c1a.svg";
export { ForwardRef as ReactComponent };